module.exports = __webpack_public_path__ + "img/wayfinder-main-features-fr.a381e588.webp";